import { useContext, useEffect, useState } from "react";
import useLoading from "../../../../Hooks/useLoading";
import useModal from "../../../../Hooks/useModal";
import { CompanyContext } from "../../../../Contexts/CompanyContext";
import { ProjectGroupingModel, ProjectWithGroupingModel } from "../../../../Models/ProjectGroupingModel";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { getGroupingByIdAPI } from "../../../../API/ProjectGroupingAPI";
import { getAllPaginatedByGroupingIdAPI, deleteProjectFromGroupingByIdAPI } from "../../../../API/ProjectWithGroupingAPI";
import ModalAddProjectToGrouping from "../ModalAddProjectToGrouping";
import { Space, Table, TableProps, Button } from "antd";
import ModalDelete from "../../../components/ModalDelete";
import { DeleteOutlined } from "@ant-design/icons";
import CardHeader from "../../../components/CardHeader";

const ProjectWithGrouping = () => {
    const { loading, toggleLoading } = useLoading();
    const { showModal, toggleShowModal } = useModal();
    const { company } = useContext(CompanyContext);
    const { id, groupingId } = useParams();
    const [projectGroupingList, setProjectGroupingList] = useState<ProjectWithGroupingModel[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [idToDelete, setIdToDelete] = useState<string>("");
    const [itemToDelete, setItemToDelete] = useState<string>("");
    const { showModal: isShowingDeleteModal, toggleShowModal: toggleDeleteModal } = useModal();
    const [grouping, setGrouping] = useState<ProjectGroupingModel>({} as ProjectGroupingModel);
    const take = 7;

    const getGrouping = async () => {
        try {
            toggleLoading(true);

            await getGroupingByIdAPI(groupingId ?? "").then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setGrouping(resp.data);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const getAllProjectsPaginatedByGroupingId = async (page: number) => {
        try {
            toggleLoading(true);

            var text = "\"\"";

            await getAllPaginatedByGroupingIdAPI(groupingId ?? "", page, take, text).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setProjectGroupingList(resp.data.items);
                    setTotal(resp.data.total);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const deleteGroupingById = async (id: string) => {
        try {
            toggleLoading(true);

            await deleteProjectFromGroupingByIdAPI(id, company.id, groupingId ?? "").then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success("Projeto deletado do agrupamento com sucesso!");
                    getAllProjectsPaginatedByGroupingId(1);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    function deleteRow(idRow: string, name: string) {
        setIdToDelete(idRow);
        setItemToDelete(name);
        toggleDeleteModal();
    }

    function responseModalDelete(resp: boolean) {
        if (resp) {
            deleteGroupingById(idToDelete);
        } else {
            setIdToDelete("");
            setItemToDelete("");
        }
    }

    useEffect(() => {
        if (groupingId != undefined) {
            getGrouping();
            getAllProjectsPaginatedByGroupingId(1);
        }
    }, [groupingId]);

    const ProjectWithGroupingColumns: TableProps<ProjectWithGroupingModel>['columns'] = [
        {
            key: "projectName",
            dataIndex: "projectName",
            showSorterTooltip: { target: 'full-header' },
            filters: projectGroupingList.map(item => ({
                text: item.projectName,
                value: item.projectName,
            })),
            onFilter: (value, record) => record.projectName.indexOf(value as string) === 0,
            title: "Nome do Projeto",
            width: '50%'
        },
        {
            key: "projectBudget",
            dataIndex: "projectBudget",
            showSorterTooltip: { target: 'full-header' },
            title: "Orçamento do Projeto",
            render: (value, row, index) => {
                return <span>R$ {value.toLocaleString('pt-BR')}</span>;
            },
            sorter: (a, b) => a.projectBudget - b.projectBudget,
            sortDirections: ['descend', 'ascend'],
        },
        {
            key: "projectName",
            dataIndex: "projectName",
            title: "Ações",
            width: '10%',
            render: (_, record) => (
                <Space size="small">
                    <Button type="text" size="middle" onClick={() => deleteRow(record.id, record.projectName)}><DeleteOutlined className="red-delete" /></Button>
                </Space>
            ),
        },
    ];

    return (
        <div className='card ms-2 me-2'>
            <CardHeader
                pageName={grouping.name}
                hasPageBefore={true}
                linkPageBefore={`/projectGrouping/${id}`}
                pageBeforeName={"Agrupamento de Projetos"}
            />
            <div className='card-body mt-4'>
                <Table
                    loading={loading}
                    rowKey="id"
                    pagination={{
                        total: total,
                        pageSize: take,
                        onChange: (page, pageSize) => {
                            getAllProjectsPaginatedByGroupingId(page);
                        },
                    }}
                    dataSource={projectGroupingList}
                    columns={ProjectWithGroupingColumns}
                />

                <Button className="w-100 mt-3" type="primary" onClick={toggleShowModal}>Inserir Projeto</Button>
            </div>
            <ModalAddProjectToGrouping
                toggleShowModal={toggleShowModal}
                year={grouping.year}
                showModal={showModal}
                groupingId={groupingId ?? ""}
                getAllProjectsPaginatedByGroupingId={getAllProjectsPaginatedByGroupingId}
            />
            <ModalDelete
                show={isShowingDeleteModal}
                toggleShow={toggleDeleteModal}
                setResponse={responseModalDelete}
                itemName={`projeto: ${itemToDelete}`}
            />
        </div>
    )
}

export default ProjectWithGrouping;